import { ExportButton } from '../../../uiComponents/ExportButton';
import { OccupationByBranchFilter } from '../../ReportFilter/OccupationByBranchFilter';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { occupationByBranchConst } from '../../../../constants';
import { formatFileName } from '../../../../util/strings';
import { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearOccupationByBranch } from '../../../../appRedux/actions/Reports';
import { DataNotFound } from '../DataNotFound';
import { ReportTableHeader } from '../../../uiComponents/ReportTableHeader';

export const OccupationByBranchReport = () => {
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const { occupationByBranch } = useSelector((state) => state.reports);
  const { fullname, role } = useSelector((state) => state.userAuth);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: formatFileName(occupationByBranchConst.title),
    sheet: occupationByBranchConst.title,
  });
  const hasData = !!Object.keys(occupationByBranch).length;
  const header = useMemo(() => occupationByBranchConst.header, []);
  const ranges = useMemo(() => occupationByBranchConst.colorRanges || {}, []);

  const getColor = (pct) => {
    const match = Object.values(ranges).find((r) => pct >= r.min && pct <= r.max);
    return match?.color || ranges?.high?.color || '#9FE47D';
  };
  const columns = useMemo(() => ([
    { key: 'branch', colSpan: 2, align: 'center', style: { padding: '15px' } },
    { key: 'pctMedic', colSpan: 2, align: 'center', style: { padding: '15px' } },
    { key: 'pctValoration', colSpan: 2, align: 'center', style: { padding: '15px' } },
    { key: 'pctCosmetologic', colSpan: 2, align: 'center', style: { padding: '15px' } },
    { key: 'pctAverage', colSpan: 2, align: 'center', style: { padding: '15px' } },
  ]), []);
  const totalColSpan = useMemo(() => columns.reduce((sum, c) => sum + (c.colSpan || 1), 0), [columns]);
  const legendKeys = useMemo(() => Object.keys(occupationByBranchConst.legend), []);

  useEffect(() => {
    dispatch(clearOccupationByBranch());
  }, [dispatch]);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <ExportButton onDownload={onDownload} disabled={!hasData} />
        <OccupationByBranchFilter />
      </div>
      <div ref={tableRef}>
        {hasData ? (<table style={{ margin: '0 auto' }}>
          <ReportTableHeader
            user={fullname}
            role={role}
            title={occupationByBranchConst.title}
            col1={6}
            col2={0}
            col3={12}
          />
          <tbody>
            <tr>
              {header?.map((item, key) => (
                <th
                  key={key}
                  colSpan={2}
                  style={{ border: '1px solid black', padding: '15px' }}
                >
                  {item}
                </th>
              ))}
            </tr>
            {occupationByBranch.map((row, key) => (
              <tr key={key}>
                {columns.map((col) => {
                  const baseStyle = {
                    border: '1px solid black',
                    textAlign: col.align || 'left',
                  };
                  const extraStyle = typeof col.dynamicStyle === 'function' ? col.dynamicStyle(row) : {};
                  const isPct = typeof row[col.key] !== 'undefined' && String(col.key).toLowerCase().includes('pct');
                  const pctStyle = isPct ? { backgroundColor: getColor(Number(row[col.key])) } : {};
                  const fixedStyle = col.style || {};
                  return (
                    <td key={col.key} colSpan={col.colSpan} style={{ ...baseStyle, ...fixedStyle, ...extraStyle, ...pctStyle }}>
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
          <tfoot>
            {legendKeys.map((level) => (
              <tr key={level}>
                <td
                  colSpan={totalColSpan}
                  style={{
                    backgroundColor: ranges?.[level]?.color,
                    textAlign: 'center',
                    padding: '10px',
                  }}
                >
                  <b>{occupationByBranchConst.legend[level]}</b>
                </td>
              </tr>
            ))}
          </tfoot>
        </table>) : <DataNotFound />}
      </div>
    </div >
  );
};